// ** Type import
import { HorizontalNavItemsType } from 'src/@core/layouts/types'

const navigation = (): HorizontalNavItemsType => [
  {
    title: 'Inicio',
    path: '/',
    icon: 'mdi:home-outline'
  },
  {
    title: 'Notificaciones',
    path: '/notifications',
    icon: 'mdi:bell-outline'
  }
]

export default navigation
